import React, { useState } from "react"
import { Card, CardContent, Typography, IconButton } from "@mui/material"
import { ThumbUp, Delete } from "@mui/icons-material"
import { doc, updateDoc, increment, deleteDoc } from "firebase/firestore"
import { db } from "../firebase/config"
import styles from "../styles/QuestionItem.module.scss"
import moment from "moment"
import toast from "react-hot-toast"

const QuestionItem = ({ question, id, admin }) => {
  const [upvoted, setUpvoted] = useState(false)

  const upvote = async () => {
    if (upvoted) return
    const questionRef = doc(db, "questions", id)
    await updateDoc(questionRef, { upvotes: increment(1) })
    setUpvoted(true)
  }

  const deleteQuestion = async () => {
    // const loadingToast = toast.loading("Deleting question...")

    try {
      const questionRef = doc(db, "questions", id)
      await deleteDoc(questionRef)
      toast.success("Question deleted!")
    } catch (error) {
      toast.error("Failed to delete question!")
      console.error("Delete error:", error)
    }
  }

  const messageDate = question ? question.createdAt?.toDate() : null
  const isAdminMessage = question?.author === "admin" || false

  return (
    <Card className={styles.card}>
      <CardContent sx={{ backgroundColor: isAdminMessage ? "#c1eff4" : "" }}>
        <Typography
          variant="body1"
          sx={{ textAlign: isAdminMessage ? "right" : "left" }}
        >
          {question.text}
        </Typography>
        <div
          className={styles.actions}
          style={{
            flexDirection: isAdminMessage && !admin ? "row-reverse" : "row"
          }}
        >
          <IconButton
            onClick={upvote}
            color={upvoted ? "secondary" : "primary"}
          >
            <ThumbUp />
          </IconButton>
          <Typography variant="caption">{question.upvotes} Upvotes</Typography>
          {admin && (
            <IconButton onClick={deleteQuestion} color="error">
              <Delete />
            </IconButton>
          )}
        </div>
        {messageDate && <small>{moment(messageDate).format("h:mm A")}</small>}
        {/* <br /> */}
        {isAdminMessage && <small> ( Shamodha Sahan )</small>}
      </CardContent>
    </Card>
  )
}

export default QuestionItem
